import { useCallback, useEffect, useState } from "react";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { getSchoolTeachers, getTeachers } from "firestoreService";
import PageHeader from "./PageHeader";
import InstituteTeachers from "./InstituteTeachers";
import SchoolTeachers from "./SchoolTeachers";

// The tab strip used to be <Box className="tabs"> styled from App.css, which
// meant the admin panel carried its own parallel styling system next to the
// theme. These are MUI Tabs now, so they inherit the brand palette.
const Teachers = () => {
  const [institute, setInstitute] = useState([]);
  const [school, setSchool] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [tab, setTab] = useState(0);

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const [instituteRows, schoolRows] = await Promise.all([getTeachers(), getSchoolTeachers()]);
      setInstitute(instituteRows);
      setSchool(schoolRows);
    } catch (loadError) {
      console.error("Could not load teachers:", loadError);
      setError("Could not load the teacher lists.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <>
      <PageHeader title="Teachers" description="Profiles published on the public Teachers pages." />

      {error && (
        <Alert severity="error" sx={{ mb: 3 }} action={<Button onClick={load}>Retry</Button>}>
          {error}
        </Alert>
      )}

      <Tabs
        value={tab}
        onChange={(event, value) => setTab(value)}
        sx={{ mb: 2.5, borderBottom: "1px solid #e3e8f0" }}
      >
        <Tab
          label={`A1 Institute (${institute.length})`}
          sx={{ textTransform: "none", fontSize: "0.9rem" }}
        />
        <Tab
          label={`A1 Play School (${school.length})`}
          sx={{ textTransform: "none", fontSize: "0.9rem" }}
        />
      </Tabs>

      {loading ? (
        <Box sx={{ display: "grid", placeItems: "center", py: 8 }}>
          <CircularProgress />
        </Box>
      ) : tab === 0 ? (
        <InstituteTeachers data={institute} reload={load} />
      ) : (
        <SchoolTeachers data={school} reload={load} />
      )}
    </>
  );
};

export default Teachers;
